/* eslint-ignore */
// @ts-nocheck
import React from 'react';

import { MdArrowForward, MdPlayArrow } from 'react-icons/md';
import { RiCheckboxCircleLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import ContainedButton from '~/components/layout/form/containedButton';
import { ButtonContainer, Section, SuccessContainer } from './styles';
import { HeaderContainer } from '../styles';

const Concluded = () => {
  return (
    <Section>
      <HeaderContainer>
        <span>
          <MdPlayArrow />
          &nbsp;&nbsp;Redefinir senha
        </span>
        <h1>Tudo certo!!</h1>
        <h2>Agora você pode acessar seu portal utilizando sua nova senha.</h2>
      </HeaderContainer>

      <SuccessContainer>
        <RiCheckboxCircleLine size={60} />
        <p>Sua senha foi redefinida com sucesso!</p>
      </SuccessContainer>

      <ButtonContainer>
        <Link to="/">
          <ContainedButton
            color="#4EC937"
            TrailingIcon={() => <MdArrowForward size={20} />}
          >
            Acesse o portal
          </ContainedButton>
        </Link>
      </ButtonContainer>
    </Section>
  );
};

export default Concluded;
